<template>
  <figure :class="['pb-quote', 'tc', { sample, compact }]">
    <span v-if="sample" class="tc-sample">Sample</span>
    <div v-if="item.rating && showRating" class="pb-stars" role="img" :aria-label="'Rated ' + item.rating + ' out of 5'">
      <i v-for="n in 5" :key="n" :class="['mdi', 'mdi-star', { off: n > item.rating }]" aria-hidden="true"></i>
    </div>
    <blockquote class="pb-quote-text tc-text">{{ item.text }}</blockquote>
    <figcaption class="pb-quote-by">
      <img v-if="photoSrc" :src="photoSrc" :alt="item.name ? 'Photo of ' + item.name : ''" width="40" height="40" loading="lazy">
      <span v-else-if="item.name" class="pb-avatar" aria-hidden="true">{{ monogram }}</span>
      <span class="tc-who">
        <span class="pb-quote-name">{{ item.name || item.byline || 'A customer' }}</span>
        <span v-if="role" class="pb-quote-meta">{{ role }}</span>
        <span v-if="item.source" class="pb-quote-meta">{{ item.source }}</span>
        <span v-if="item.date && showDate" class="pb-quote-meta">{{ when }}</span>
      </span>
    </figcaption>
  </figure>
</template>

<script>
import { initials } from '../lib/color';
import { formatDate } from '../lib/format';
import { imageUrl } from '../publicUrls';

export default {
  name: 'TestimonialCard',
  props: {
    // The public shape: {text, name, byline, job_title, company, photo (public key) or photo_url, rating, source, date}.
    item: { type: Object, required: true },
    sample: { type: Boolean, default: false },
    compact: { type: Boolean, default: false },
    showRating: { type: Boolean, default: true },
    showDate: { type: Boolean, default: false }
  },
  computed: {
    photoSrc() { return this.item.photo_url || (this.item.photo ? imageUrl(this.item.photo) : ''); },
    monogram() { return initials(this.item.name || ''); },
    role() { return [this.item.job_title, this.item.company].filter(Boolean).join(', '); },
    when() { return formatDate(this.item.date); }
  }
};
</script>

<style scoped>
.tc{margin:0;display:flex;flex-direction:column;break-inside:avoid}
.tc-text{white-space:pre-line;overflow-wrap:anywhere}
.tc-who{display:flex;flex-direction:column;min-width:0}
.tc.compact{padding:20px 18px 16px}
.tc.compact .tc-text{font-size:15.5px}
.tc.sample{border-style:dashed}
.tc.sample::before{content:none}
.tc-sample{position:absolute;top:12px;right:12px;padding:2px 8px;border-radius:999px;background:#F3EEE6;color:#4F4A45;
  font:700 11px/1.5 var(--font-body);letter-spacing:.06em;text-transform:uppercase}
</style>
